import { Box, Fab, Stack, Tooltip, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faAdd,
  faCirclePlus,
  faCircleMinus,
  faMinus,
  faChevronLeft,
  faChevronRight,
  faCircleUp,
  faCircleDown,
} from "@fortawesome/free-solid-svg-icons";

export const CollapseVertical = ({ label, onClick, color = "primary" }) => {
  return (
    <Fab
      color={color}
      style={{ transform: "rotate(90deg) scale(0.6)" }}
      sx={{ pl: 5, pr: 5, marginRight: -13, mt: 5, ml: -13 }}
      size="small"
      variant="extended"
      onClick={(e) => onClick()}
    >
      {label}
    </Fab>
  );
};


export const CollapseStateLabel = ({ add, label, onClick }) => {
  return (
    <Fab
      color="primary"
      style={{ transform: "scale(0.7)" }}
      sx={{ pl: 5, pr: 5 }}
      size="small"
      variant="extended"
      onClick={(e) => onClick(!add)}
    >
      <FontAwesomeIcon
        onClick={(e) => onClick(!add)}
        size="lg"
        icon={add ? faMinus : faAdd}
      />
      {label}
    </Fab>
  );
};

export const CollapseShiftLabel = ({
  add,
  label,
  onClick,
  disabled = false,
  color = "primary",
}) => {
  return (
    <Fab
      color={color}
      style={
        label !== undefined
          ? { transform: "scale(0.7)" }
          : { transform: "scale(0.5)" }
      }
      // sx={{ pl: 1, pr: 1 }}
      size="small"
      disabled={disabled}
      variant="extended"
    >
      <FontAwesomeIcon
        onClick={(e) => onClick(!add)}
        size="xl"
        icon={add ? faChevronLeft : faChevronRight}
      />
      {label}
    </Fab>
  );
};

export const CollapseAdd = ({ onClick, tooltip, disabled = false }) => {
  return (
    <Tooltip title={tooltip}>
      <FontAwesomeIcon
        className={disabled ? "disabled-icon" : "blue-icon"}
        onClick={() => { if (!disabled) { onClick() } }}
        size="lg"
        //color="aqua"
        // style={{ transform: "scale(0.5)" }}
        icon={faCirclePlus}
      />
    </Tooltip>
  );
};

export const CollapseDelete = ({ onClick, tooltip }) => {
  return (
    <Tooltip title={tooltip}>

      <FontAwesomeIcon
        onClick={onClick}
        size="lg"
        color="lightgrey"
        icon={faCircleMinus}
      />
    </Tooltip>

  );
};

export const CollapseAddLabel = ({ label = "", onClick, tooltip = "", mt = 0, disabled = false }) => {
  return (
    <Box>
      <Stack sx={{ mt: -3 + mt }}>
        <Typography variant="caption">
          {label}
        </Typography>
        <CollapseAdd
          onClick={onClick}
          tooltip={tooltip}
          disabled={disabled}
        />
      </Stack>
    </Box>
  )
}

export const CollapseDeleteLabel = ({ label = "", onClick, tooltip = "" }) => {
  return (
    <Box>
      <Stack sx={{ mt: label === "" ? 2 : -4 }}>
        <Typography variant="caption">
          {label}
        </Typography>
        <CollapseDelete
          onClick={onClick}
          tooltip={tooltip}
        />
      </Stack>
    </Box>
  )
}

export const Up = ({ onClick }) => {
  return (
    <FontAwesomeIcon
      onClick={onClick}
      size="lg"
      className="blue-icon"
      icon={faCircleUp}
    />
  );
};
export const Down = ({ onClick }) => {
  return (
    <FontAwesomeIcon
      onClick={onClick}
      size="lg"
      className="blue-icon"
      icon={faCircleDown}
    />
  );
};